/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import store from "../../store/store";
import { leaveCurrentHoverElement, setCurrentHoverElement } from "../../store/slice/roomSlices/topologyRoomSlice";

export const getColorFromStatus = (status) => {
    switch (status) {
        case "Ready":
        case "Suppressed by condition":
        case "Undecided":
        case "Waiting":
        case "Held":
            return "#A6A5A6";
        case "Successful":
            return "#00a95d";
        case "Running":
            return "#6c87c3";
        case "Error":
        case "Blocked":
            return "#f15d4d";
        case "Canceled":
            return "#595859";
        default:
            break;
    }
};

export const getIconFromStatus = (status) => {
    switch (status) {
        case "Ready":
            return "#ReadyStatus";
        case "Suppressed by condition":
            return "#SuppressedStatus";
        case "Undecided":
            return "#UndecidedStatus";
        case "Waiting":
            return "#WaitingStatus";
        case "Held":
            return "#WaitingStatus";
        case "Successful":
            return "#SuccessfulStatus";
        case "Running":
            return "#RunningStatus";
        case "Error":
            return "#ErrorStatus";
        case "Blocked":
            return "#BlockedStatus";
        case "Canceled":
            return "#CanceledStatus";
        default:
            break;
    }
};

export const nodeGenerator = (node) => {
    const canModify = store.getState().private.device.canModify;
    const width = 32;
    const height = 12;
    const depth = 2;

    //Upper Panel
    const domNodeUpperPanel = document.createElement("a-entity");
    domNodeUpperPanel.setAttribute("geometry", {
        primitive: "box",
        height: height * 0.3,
        width,
        depth,
    });
    domNodeUpperPanel.setAttribute("material", {
        color: getColorFromStatus(node.status),
    });

    //Upper Panel Icon
    const domNodeUpperPanelIcon = document.createElement("a-entity");
    domNodeUpperPanelIcon.setAttribute("material", {
        src: getIconFromStatus(node.status),
        transparent: true,
    });
    domNodeUpperPanelIcon.setAttribute("geometry", {
        primitive: "plane",
        height: height * 0.3,
        width: height * 0.3,
    });
    domNodeUpperPanelIcon.setAttribute("position", {
        z: depth / 2 + 0.1,
    });
    domNodeUpperPanel.appendChild(domNodeUpperPanelIcon);

    //Bottom Panel
    const domNodeBottomPanel = document.createElement("a-entity");
    domNodeBottomPanel.setAttribute("geometry", {
        primitive: "box",
        height: height * 0.7,
        width,
        depth,
    });
    domNodeBottomPanel.setAttribute("material", {
        color: "#262626",
    });
    domNodeBottomPanel.setAttribute("position", {
        y: -height * 0.15 - height * 0.35,
    });

    //Text
    const domNodeBottomPanelText = document.createElement("a-entity");
    const label = `${node.workstation}#${node.workflow}\n${node.job}`;

    domNodeBottomPanelText.setAttribute("text", {
        value: label,
        color: "#c6c6c6",
        align: "center",
        width: width * 0.9,
        wrapCount: 25,
        font: window.AFRAME.customFont || null,
        negate: window.AFRAME.customFont ? "false" : "true",
    });
    domNodeBottomPanelText.setAttribute("position", {
        z: depth / 2 + 0.5,
    });
    domNodeBottomPanel.appendChild(domNodeBottomPanelText);

    //Main Node
    const domNode = document.createElement("a-entity");
    domNode.appendChild(domNodeUpperPanel);
    domNode.appendChild(domNodeBottomPanel);
    if (node.isSelected) {
        domNodeBottomPanel.className = canModify ? "collidable" : "";
        domNodeUpperPanel.className = canModify ? "collidable" : "";
        domNode.addEventListener("mouseenter", (e) => {
            e.stopPropagation();
            store.dispatch(setCurrentHoverElement({
                id: node.id,
                workstation: node.workstation,
                workflow: node.workflow,
                job: node.job,
                status: node.status,
                folder: node.folder,
                start: node.start,
            }));
            domNode.setAttribute("scale", "1.5 1.5 1.5");
        });
        domNode.addEventListener("mouseleave", (e) => {
            e.stopPropagation();
            store.dispatch(leaveCurrentHoverElement());
            domNode.setAttribute("scale", "1 1 1");
        });
        domNode.addEventListener("click", (e) => {
            e.currentTarget.emit("elementSelected");
        });
    } else {
        domNode.setAttribute("visible", false);
    }
    return domNode;
};
